var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:(_vm.info.isExitRow ? 'small-map-block' : 'map-block') + ' exit exit-' + _vm.direction},[_c('span',{staticClass:"exit-text"})])}
var staticRenderFns = []

export { render, staticRenderFns }